(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-collection-tabs"] && !Shopify.designMode) return;
  try {
    
function initSurfTabs(root=document){
  root.querySelectorAll('[data-ss-tabs]').forEach(section=>{
    if(section.dataset.ready)return;
    section.dataset.ready='true';
    const tabs=[...section.querySelectorAll('[role=tab]')];
    const tracks=[...section.querySelectorAll('[data-ss-track]')];
    const controls=section.querySelector('[data-ss-controls]');
    const previous=section.querySelector('[data-ss-prev]');
    const next=section.querySelector('[data-ss-next]');
    const controller=new AbortController();
    const listenerOptions={signal:controller.signal};
    const activeTrack=()=>tracks.find(track=>!track.closest('[role=tabpanel]').hidden);
    let lastClickedTab=null;
    let frame=0;
    const update=()=>{
      frame=0;
      const track=activeTrack();
      if(!track)return;
      const maximum=track.scrollWidth-track.clientWidth;
      controls.hidden=maximum<=1;
      previous.disabled=track.scrollLeft<=1;
      next.disabled=track.scrollLeft>=maximum-1;
      previous.setAttribute('aria-controls',track.id);
      next.setAttribute('aria-controls',track.id);
    };
    const scheduleUpdate=()=>{if(!frame)frame=requestAnimationFrame(update);};
    const scroll=direction=>{
      const track=activeTrack();
      if(!track?.firstElementChild)return;
      const step=track.firstElementChild.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).columnGap)||0);
      const visible=Math.max(1,Math.round(track.clientWidth/step));
      const index=Math.round(track.scrollLeft/step);
      track.scrollTo({left:(index+direction*visible)*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    };
    const select=tab=>{
      lastClickedTab=null;
      tabs.forEach(item=>{
        const active=item===tab;
        item.setAttribute('aria-selected',String(active));
        item.tabIndex=active?0:-1;
        section.querySelector('[id="'+item.getAttribute('aria-controls')+'"]').hidden=!active;
      });
      update();
    };
    previous.addEventListener('click',()=>scroll(-1),listenerOptions);
    next.addEventListener('click',()=>scroll(1),listenerOptions);
    tracks.forEach(track=>{
      track.addEventListener('scroll',scheduleUpdate,{passive:true,signal:controller.signal});
      track.addEventListener('keydown',event=>{
        if(event.target!==track)return;
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
          event.preventDefault();
          scroll(event.key==='ArrowRight'?1:-1);
        }
      },listenerOptions);
    });
    tabs.forEach((tab,i)=>{
      tab.addEventListener('click',()=>{
        if(lastClickedTab===tab&&tab.getAttribute('aria-selected')==='true'&&tab.dataset.collectionUrl){window.location.assign(tab.dataset.collectionUrl);return;}
        select(tab);
        lastClickedTab=tab;
      },listenerOptions);
      tab.addEventListener('keydown',event=>{
        let index;
        if(event.key==='ArrowRight')index=(i+1)%tabs.length;
        if(event.key==='ArrowLeft')index=(i-1+tabs.length)%tabs.length;
        if(event.key==='Home')index=0;
        if(event.key==='End')index=tabs.length-1;
        if(index!==undefined){event.preventDefault();select(tabs[index]);tabs[index].focus();}
      },listenerOptions);
    });
    const observer=new ResizeObserver(scheduleUpdate);
    observer.observe(section);
    document.addEventListener('shopify:section:unload',event=>{
      if(!event.target.contains(section))return;
      observer.disconnect();
      cancelAnimationFrame(frame);
      controller.abort();
    },listenerOptions);
    update();
  });
}
document.addEventListener('DOMContentLoaded',()=>initSurfTabs());
document.addEventListener('shopify:section:load',event=>initSurfTabs(event.target));
initSurfTabs();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-new-in"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ss-new-in')) {
    customElements.define('ss-new-in', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        const track = this.querySelector('.ss-new-in__track');
        const buttons = this.querySelectorAll('[data-direction]');
        if (!track || buttons.length !== 2) return;
        const update = () => {
          buttons[0].disabled = track.scrollLeft <= 2;
          buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const card = track.firstElementChild;
          if (!card) return;
          const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
          const visible = Math.max(1, Math.floor((track.clientWidth + parseFloat(getComputedStyle(track).gap) + 1) / step));
          track.scrollBy({ left: Number(button.dataset.direction) * step * visible, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal }));
        track.addEventListener('scroll', update, { passive: true, signal });
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            buttons[event.key === 'ArrowRight' ? 1 : 0].click();
          }
        }, { signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
        update();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-newsletter-popin"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ss-newsletter-popin')) {
    customElements.define('ss-newsletter-popin', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.teaser = this.querySelector('.ss-newsletter-popin__teaser');
        this.trigger = this.querySelector('.ss-newsletter-popin__trigger');
        this.dialog = this.querySelector('dialog');
        this.storageKey = 'ss-newsletter-dismissed-until';
        this.successKey = 'ss-newsletter-subscribed';
        const stored = key => {try {return localStorage.getItem(key);} catch {return null;}};
        const result = this.querySelector('[data-newsletter-success], [data-newsletter-error]');
        const returnedHere = new URLSearchParams(location.search).get('ss_newsletter') === '1';
        this.subscribed = this.dataset.alreadySubscribed === 'true' || stored(this.successKey) === 'true';
        if (result && returnedHere) {
          if (result.hasAttribute('data-newsletter-success')) {
            this.subscribed = true;
            this.remember(this.successKey, 'true');
          }
          this.open();
          result.focus({preventScroll:true});
        } else if (!this.subscribed && Number(stored(this.storageKey)) < Date.now()) {
          this.teaser.hidden = false;
        }
        this.trigger.addEventListener('click', () => this.open(), options);
        this.querySelector('.ss-newsletter-popin__dismiss').addEventListener('click', () => {
          this.teaser.hidden = true;
          this.remember(this.storageKey, Date.now() + Number(this.dataset.dismissDays) * 86400000);
        }, options);
        this.querySelector('.ss-newsletter-popin__close').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('ss-newsletter-dialog-open');
          this.teaser.hidden = this.subscribed;
          if (!this.subscribed) this.trigger.focus({preventScroll:true});
        }, options);
      }
      remember(key, value) {
        try {localStorage.setItem(key, String(value));} catch { /* The form also works when browser storage is unavailable. */ }
      }
      open() {
        if (this.dialog.open) return;
        this.teaser.hidden = true;
        this.dialog.showModal();
        document.documentElement.classList.add('ss-newsletter-dialog-open');
        this.dialog.querySelector('input[type="email"]')?.focus({preventScroll:true});
      }
      disconnectedCallback() {
        this.dialog?.close();
        this.controller?.abort();
        this.controller = null;
        document.documentElement.classList.remove('ss-newsletter-dialog-open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-trustpilot-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ss-review-carousel'))customElements.define('ss-review-carousel',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.track=this.querySelector('.ss-reviews-track');this.cards=[...this.querySelectorAll('.ss-review-card')];this.dots=[...this.querySelectorAll('[data-slide]')];this.controls=this.querySelector('.ss-reviews-controls');this.prev=this.querySelector('[data-direction="-1"]');this.next=this.querySelector('[data-direction="1"]');this.querySelectorAll('[data-direction]').forEach(b=>b.addEventListener('click',()=>this.go(this.index+Number(b.dataset.direction))));this.dots.forEach(b=>b.addEventListener('click',()=>this.go(Number(b.dataset.slide))));this.track.addEventListener('scroll',()=>this.update(),{passive:true});this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1));}});this.onSelect=e=>{const i=this.cards.indexOf(e.target.closest('.ss-review-card'));if(i>=0)this.go(i);};this.addEventListener('shopify:block:select',this.onSelect);this.observer=new ResizeObserver(()=>this.update());this.observer.observe(this.track);this.update();}
disconnectedCallback(){this.observer?.disconnect();}
positions(){const first=this.cards[0];if(!first)return[];const max=this.track.scrollWidth-this.track.clientWidth;return this.cards.map(c=>Math.min(max,c.offsetLeft-first.offsetLeft));}
update(){const positions=this.positions();const unique=[...new Set(positions.map(p=>Math.round(p)))];this.positionsList=unique;this.index=unique.reduce((best,p,i)=>Math.abs(p-this.track.scrollLeft)<Math.abs(unique[best]-this.track.scrollLeft)?i:best,0);this.controls.hidden=unique.length<2;this.prev.disabled=this.index===0;this.next.disabled=this.index===unique.length-1;this.dots.forEach((b,i)=>{b.hidden=i>=unique.length;b.setAttribute('aria-current',String(i===this.index));});}
go(index){this.update();const i=Math.max(0,Math.min(index,this.positionsList.length-1));this.track.scrollTo({left:this.positionsList[i],behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-winter-offers"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ss-winter-offers'))customElements.define('ss-winter-offers',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('ul');const buttons=this.querySelectorAll('button');const update=()=>{buttons[0].disabled=track.scrollLeft<2;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.direction)*(track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));track.addEventListener('scroll',update,{passive:true});this.observer=new ResizeObserver(update);this.observer.observe(track);update();}
 disconnectedCallback(){this.observer?.disconnect();this.ready=false;}
});

  } catch(e) { console.error(e); }
})();
})();
